
import colors from 'shared-tokens/utils/tokens/colors';
import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brTablet = createBreakpoint('s');
const brDesktop = createBreakpoint('m');

export const mainCls = 'csaSrpcard';

export default {
  [mainCls]: {
    marginRight: 8,
    marginBottom: 16,
    marginLeft: 8,
    borderRadius: 8,
    minWidth: 'calc(100% - 16px)',
    overflow: 'hidden',
    '&.mapcard': {
      marginRight: 0,
      marginLeft: 0,
      marginBottom:0,
      width: 'calc(100vw - 48px)',
      minWidth: 'calc(100vw - 48px)',
      [brTablet]: {
        width: 284,
        minWidth: '100%',  
        borderRadius: 8,
        overflow: 'hidden',
      },
    },
    '&.maplist': {
      borderRadius: '8px !important',
      overflow: 'hidden !important',
    },
    [brTablet]: {
      minWidth: '100%',
      borderRadius: 4,
      overflow: 'visible',
      '@media (hover: hover)': {
        transition: createTransition(['border-color']),
        '&:hover': {
          borderColor: `${colors.borderdark.rgba} !important`,
          '& .csaSrpcard__det__title--a': {
            textDecoration: 'underline',
          },
          '& .csaSrpcard__det__contacts__sendmail': {
            color: '#FFF !important',
            borderColor: `${colors.secondary.rgba} !important`,
            backgroundColor: `${colors.secondary.rgba} !important`,
          },
          '& .csaSrpcard__gal__slider__arrows': {
            opacity: 1,
            pointerEvents: 'all',
          },
          '& .csaSrpcard__det__contacts__pin': {
            color: `${colors.f0.rgba} !important`,
          }
        },
      },
    },
    [brDesktop]: {
      marginRight: 0,
      marginLeft: 0,
    },
  },
  [`${mainCls}__cnt-card`]: {
    [brTablet]: {
      marginRight: 16,
      '&.forMapcard': {
        marginRight: 0,  
      },
    },
    [brDesktop]: {
      marginRight: 0,
      marginLeft: 0,
    },
  },
  [`${mainCls}__anchor`]: {
    position: 'absolute',
    top: -75,
    left: 0,
  },
  [`${mainCls}__depth`]: {
    marginBottom: 2,
    paddingRight: 16,
    fontSize: 10,
    [brTablet]: {
      paddingRight: 8,
    },
  },
  [`${mainCls}__inner`]: {
    flexDirection: 'column',
    maxWidth: '100%',
    [brTablet]: {
      flexDirection: 'row',
    },
  },
};
